// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"f05c52bf","236":"cc1928a7","391":"d40b823c","641":"9101d2fc","650":"3cd11c6d","772":"59e35fb7","846":"445abaa1"}[chunkId] + ".chunk.js";
};